import { lazy, Suspense, useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { createAppRouter } from './appRouter';
import { isDemoVariant } from './demo/config';
import { useAuthStore } from './stores/authStore';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { DemoViewNotice } from './features/demo-visitor/DemoViewNotice';
import { DemoCopyNotice } from './features/demo-copies/DemoCopyNotice';
import { DemoCopyTracker } from './features/demo-copies/DemoCopyTracker';

let hasBootstrappedAuth = false;

function AuthBootstrap(): null {
  const checkAuth = useAuthStore((state) => state.checkAuth);

  useEffect(() => {
    if (hasBootstrappedAuth) return;
    hasBootstrappedAuth = true;
    void checkAuth();
  }, [checkAuth]);

  return null;
}

const DemoApplication = lazy(() => import('./demo/DemoApplication'));
const router = isDemoVariant ? null : createAppRouter();
const loading = <div className="p-8 text-sm text-muted-foreground">Loading…</div>;

export default function App() {
  return (
    <>
      {!isDemoVariant && <AuthBootstrap />}
      {!isDemoVariant && <DemoViewNotice />}
      {!isDemoVariant && <DemoCopyNotice />}
      <ErrorBoundary>
        {!isDemoVariant && <DemoCopyTracker />}
        <Suspense fallback={loading}>
          {router ? <RouterProvider router={router} fallbackElement={loading} /> : <DemoApplication />}
        </Suspense>
      </ErrorBoundary>
      <Toaster position="top-right" richColors closeButton />
    </>
  );
}
